import { render, staticRenderFns } from "./organization-relation-list-group-input.vue?vue&type=template&id=f7b22150&scoped=true&"
import script from "./organization-relation-list-group-input.vue?vue&type=script&lang=ts&"
export * from "./organization-relation-list-group-input.vue?vue&type=script&lang=ts&"
import style0 from "./organization-relation-list-group-input.vue?vue&type=style&index=0&id=f7b22150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b22150",
  null
  
)

export default component.exports